'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  svg {\n    color: ', ';\n    font-size: 20px;\n  }\n\n  .tooltip {\n    line-height: 1.2em;\n    max-width: 200px;\n    padding: 10px 15px;\n  }\n'], ['\n  svg {\n    color: ', ';\n    font-size: 20px;\n  }\n\n  .tooltip {\n    line-height: 1.2em;\n    max-width: 200px;\n    padding: 10px 15px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _faQuestionCircle = require('@fortawesome/free-solid-svg-icons/faQuestionCircle');

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTooltip = _styledComponents2.default.div(_templateObject, _config.colors.darkGray);

StyledTooltip.displayName = 'StyledTooltip';

var Tooltip = function Tooltip(_ref) {
  var _ref$content = _ref.content,
      content = _ref$content === undefined ? '' : _ref$content;
  return _react2.default.createElement(
    StyledTooltip,
    null,
    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faQuestionCircle.faQuestionCircle,
      role: 'tooltip',
      'aria-label': content,
      'data-tip': content
    }),
    _react2.default.createElement(_reactTooltip2.default, {
      className: 'tooltip',
      effect: 'solid'
    })
  );
};

Tooltip.propTypes = {
  content: _propTypes2.default.string
};

Tooltip.displayName = 'Tooltip';

exports.default = Tooltip;
Tooltip.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Tooltip',
  'props': {
    'content': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    }
  }
};